import clsx from 'clsx'
import { FC } from 'react'
import { THeaderInfo } from '../../../store/features/per-reserve/types'

type IProps = {
  data: THeaderInfo[]
  cols?: string | number
  classes?: string
}

const HeaderInfo: FC<IProps> = ({ data, cols, classes }) => {
  return (
    <div
      className={clsx(
        `w-full grid grid-cols-${String(cols)}
       bg-neutral-100 shadow-sm rounded-lg px-5 py-4 font-bold text-xs sm:text-sm
        ${classes}
        `,
      )}
    >
      {data &&
        data.map((item: THeaderInfo) => (
          <span key={item.key} className='inline-block text-center'>
            {item.title}
          </span>
        ))}
    </div>
  )
}

export default HeaderInfo
